export const USER_NOTIFICATION_TYPE = {
  EMAIL: 'email',
  NOTIFICATION: 'notification',
} as const;

export const USER_NOTIFICATION_TYPE_TO_TEXT = {
  [USER_NOTIFICATION_TYPE.EMAIL]: 'Notification by Email',
  [USER_NOTIFICATION_TYPE.NOTIFICATION]: 'Notification on MyG2',
} as const;
